import React, {createContext, useReducer} from 'react'
import {AlertReducer} from "../reducers/AlertReducer";

export const AlertContext = createContext();

const AlertContextProvider = (props) => {
    const state = {
        alert: {}
    }
    const [alertViewModel, alertDispatch] = useReducer(AlertReducer, state);
    return (
        <AlertContext.Provider value={{alertViewModel, alertDispatch}}>
            {props.children}
        </AlertContext.Provider>
    )
}

export default AlertContextProvider


// WEBPACK FOOTER //
// ./src/components/alert/context/AlertContext.js